import { useLiveQuery } from "dexie-react-hooks";
import { db } from "~db/db";

const useCheckIn = () => {
  const checkin = useLiveQuery(() => {
    return db.visitaAtiva.get(1);
  });

  const checkout = useLiveQuery(() => {
    return db.visitaAtiva.get(2);
  });

  const checkMissao = useLiveQuery(() => {
    return db.visitaAtiva.get(3);
  });

  return {
    checkin,
    checkout,
    checkMissao,
  };
};

export default useCheckIn;
